<template>
  <section class="section-block">
    <oie-layout-grid css-classes="grid--four grid--less-gap">
      <a
        v-for="item of categoryList"
        :key="item.id"
        :href="item.url"
        class="navigational-item navigational-item--arrow navigational-item--white category-list__item result_category"
        v-html="getCategoryHtml(item)">
      </a>
    </oie-layout-grid>
  </section>
</template>

<script>
import { renderHighlight, escapeHtml } from '@/core/search-service'

export default {
  props: {
    categoryList: {
      type: Array,
      required: true
    }
  },
  methods: {
    // Only the breadcrumbs wrapper is ours; the name may carry highlight matches from the backend,
    // parentCategories never does - both are still escaped before going into the markup (OC-2662).
    getCategoryHtml: function (item) {
      const name = renderHighlight(item.nameHighlight, item.name)
      const parentCategories = escapeHtml(item.parentCategories)

      return `${name}<div class="breadcrumbs">${parentCategories}</div>`
    }
  }
}
</script>

<style lang="scss">

  .category-list__item {
    display: block;
  }

  .category-list__item > em {
    background-color: #44B1FA;
    font-style: normal;
    color: white;
    padding: 0rem .1rem 0rem .05rem;
  }

  .category-list__item > em.instant-result__complete_match {
    background-color: #006db6;
    padding: .15rem .4rem .15rem .4rem;
    border-radius: 2px;
  }

  .category-list__item > .breadcrumbs {
    font-size: .8rem;
    margin-top: .2rem;
    font-weight: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

</style>
